export const LOGIN_SUCCESS = 'loginReducer/LOGIN_SUCCESS';
export type LOGIN_SUCCESS = typeof LOGIN_SUCCESS;

export const LOGIN_FAILURE = 'loginReducer/LOGIN_FAILURE';
export type LOGIN_FAILURE = typeof LOGIN_FAILURE;

export const LOGOUT_SUCCESS = 'loginReducer/LOGOUT_SUCCESS';
export type LOGOUT_SUCCESS = typeof LOGOUT_SUCCESS;


// WEBPACK FOOTER //
// ./src/modules/login/constants.ts